export enum MessageStatus {
    NOT_READABLE = 'NOT_READABLE',
    UNREAD = 'UNREAD',
    READ = 'READ',
    ARCHIVED = 'ARCHIVED',
    DELETED = 'DELETED'
}
